// CustomHorizontalMenu.js
import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import { styled } from '@mui/material/styles';
import { iconsNew } from './icons'; // Ensure this path is correct

import { MenuData } from './menuData'; // Import your menu data and icons

const PREFIX = 'RaHorizontalMenu';

const classes = {
    root: `${PREFIX}-root`,
    menuButton: `${PREFIX}-menuButton`,
    menuItem: `${PREFIX}-menuItem`,
    dropdownMenu: `${PREFIX}-dropdownMenu`,
};

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${classes.menuButton}`]: {
        color: theme.palette.primary.contrastText,
        textTransform: 'none',
        marginRight: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    [`& .${classes.menuItem}`]: {
        color: theme.palette.text.primary,
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}));

const CustomHorizontalMenu = () => {
    const translate = useTranslate();
    const [anchorEls, setAnchorEls] = useState({});

    const handleClick = (event, menuName) => {
        setAnchorEls({
            ...anchorEls,
            [menuName]: event.currentTarget,
        });
    };

    const handleClose = (menuName) => {
        setAnchorEls({
            ...anchorEls,
            [menuName]: null,
        });
    };

    const menuData = MenuData(); // Get your menu data

    return (
        <Root className={classes.root}>
            {menuData.map(({ name, title, icon, links }) => {
                // Check for 'root', 'root1', 'root2', etc.
                if (
                    title === 'root' ||
                    title === 'root1' ||
                    title === 'root2' ||
                    title === 'root3' ||
                    title === 'root4' ||
                    title === 'root5'
                ) {
                    // Render the links directly as buttons
                    return links.map(({ title: linkTitle, url }) => (
                        <Button
                            key={linkTitle}
                            className={classes.menuButton}
                            component={Link}
                            to={url}
                            startIcon={iconsNew[linkTitle]}
                        >
                            {translate(`resources.${linkTitle}.name`, { _: linkTitle })}
                        </Button>
                    ));
                } else if (links.length === 1) {
                    // Single link, render as Button
                    const { title: linkTitle, url } = links[0];
                    return (
                        <Button
                            key={linkTitle}
                            className={classes.menuButton}
                            component={Link}
                            to={url}
                            startIcon={iconsNew[linkTitle]}
                        >
                            {translate(`resources.${linkTitle}.name`, { _: linkTitle })}
                        </Button>
                    );
                } else {
                    // Multiple links, render as dropdown menu
                    return (
                        <div key={name}>
                            <Button
                                className={classes.menuButton}
                                onClick={(e) => handleClick(e, name)}
                                startIcon={iconsNew[title]}
                            >
                                {translate(`sections.${title}`, { _: title })}
                            </Button>
                            <Menu
                                anchorEl={anchorEls[name]}
                                open={Boolean(anchorEls[name])}
                                onClose={() => handleClose(name)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            >
                                {links.map(({ title: linkTitle, url }) => (
                                    <MenuItem
                                        key={linkTitle}
                                        component={Link}
                                        to={url}
                                        onClick={() => handleClose(name)}
                                        className={classes.menuItem}
                                    >
                                        {iconsNew[linkTitle]}
                                        {translate(`resources.${linkTitle}.name`, { _: linkTitle })}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </div>
                    );
                }
            })}
        </Root>
    );
};

export default CustomHorizontalMenu;